import css from './style.module.scss';
import { gql } from '../../util/fetchGql';
import Wrap from '../Wrap';
import Prose from '../Prose';
import cls from '../../util/cls';
import Image from 'next/image';

export const TEXT_PRODUCT_FRAGMENT = gql`
	fragment TextProduct on productContent_text_BlockType {
		images {
			... on uploads_Asset {
                url
                title
                contain
			}
		}
		text
		imagePosition
	}
`;

const Img = ({ src, i, length, className }) => {
	const n3 = i % 3 === 0
		, n3_1 = i % 3 - 1 === 0
		// , n3_2 = i % 3 - 2 === 0
		, last = i === length;

	let width, height;

	if (n3 || (n3_1 && last)) {
		width = 800;
		height = 480;
	} else {
		width = 400;
		height = 520;
	}

	return (
		<Image unoptimized
			src={src}
			width={width}
			height={height}
			className={className}
		/>
	);
};

export default function Text ({ images, text, imagePosition = 'left' }) {
	const hasImages = images?.length > 0;

	const imgs = (
		<div className={css.images}>
			{images.map((image, i) => (
				<span className={image.contain ? css.contain : ''}>
					<Img
						key={i}
						i={i}
						src={image.url}
						length={image.length - 1}
					/>
				</span>
			))}
		</div>
	);

	return (
		<Wrap grid className={css.textWrap}>
			{hasImages && imagePosition === 'left' && imgs}
			<Prose className={cls(css.text, { [css.noImages]: !hasImages })}>
				{text}
			</Prose>
			{hasImages && imagePosition === 'right' && imgs}
		</Wrap>
	);
}
